import React, { useState, useEffect, useRef, Fragment, useImperativeHandle, forwardRef } from "react";
import ColorDropdown from "../../Dropdown/ColorDropdown.js";
import EmojiesDrop from "../../../components/TextEditor/EmojiesDrop";
import CreatePortalHOC from "../../GlobalFeature/Fields/CreatePortalHOC";
import { ReactComponent as Addtag } from "../../../assets/images/icons/Addtag.svg";
import withPortalHOC from "../../UniversalComponents/WithPortalHOC.js";
import List from "../../UniversalComponents/ListComponent.js";
import { ReactComponent as DownArrow } from "../../../assets/images/downArrow.svg";
import DatePickerComponent from "../../UniversalComponents/DatePickerComponent.js";
import moment from "moment";
import {
  getHexWithOpacity,
  getTitleCase,
  predefinedColors,
  TagOptionsColored,
} from "../../../utils/utilityFunctions/stringUtility.js";
import { Dialog } from "@mui/material";
import { Email } from "@mui/icons-material";
import EmailDropDownComponent from "./EmailDropDownComponent.jsx";
import EmailPersonInfo from "./EmailPersonInfo.jsx";
import { useFetchNoteTagsQuery } from "../../../utils/customer/customerSelect.js";
import { createOption } from "../../../utils/api/customTemplatesApi.js";
import { pushAlert } from "../../../utils/alertSlice.js";
import { useDispatch } from "react-redux";
import Button from "../../UniversalComponents/DefaultButton.js";
// import EmailDropDownComponent from "./notes/EmailDropDownComponent.jsx";
// import EmailPersonInfo from "./notes/EmailPersonInfo.jsx";

const truncateFileName = (fileName, maxLength = 10) => {
  if (fileName?.length <= maxLength) {
    return fileName;
  }
  const extension = fileName?.split(".").pop();
  const baseName = fileName?.substring(0, fileName?.length - extension?.length - 1);
  return `${baseName.substring(0, maxLength - extension?.length - 4)}...${extension}`;
};

const PortalList = withPortalHOC(List);

const ViewNotesData = forwardRef(
  (
    {
      handleNotesClick,
      colourCodes,
      customerTaskCategory,
      customerColor,
      handleSubmit,
      handleInputChange,
      handleSetColour,
      formData,
      initialContent,
      setInitialContent,
      notesBody,
      textareaRef,
      handleFileUpload,
      selectedFile,
      hndleCloseNotes,
      handleClickDeleteFile,
      downloadFiles,
      handleDeleteFileServer,
      editNoteId,
      getFileLastName,
      listOpen = false,
      clickTrigger,
      multiSelect = false,
      listCloseHandler = () => null,
      selectedOptions,
      setSelectedOptions,
      selectedContent,
      setSelectedContent,
      selectedDate,
      setSelectedDate,
      mentions,
      setMentions = () => null,
    },
    ref
  ) => {
    const [activeFormatting, setActiveFormatting] = useState({
      bold: false,
      underline: false,
      italic: false,
      copy: false,
      fontSize: 3,
      fontName: "Poppins",
      formatblock: "p",
      foreColor: "#000000",
      wordcount: initialContent.trim().split(/\s+/).length,
      charactercount: initialContent?.length,
    });
    const [content, setContent] = useState(initialContent);
    const [paraHeadOpen, setParaHeadOpen] = useState(false);
    const [dropdownPosition, setDropdownPosition] = useState(null);
    const [selectedColor, setSelectedColor] = useState("#000000"); // Default color
    const [noTextSelected, setNoTextSelected] = useState(false);
    const [isOpen, setIsOpen] = useState(listOpen);
    const [showMentionPortal, setShowMentionPortal] = useState(false); // used to track record of whether email dropdown portal is open or not
    const mentionRef = useRef(null); //used to pass the ref of the @ to the Portal, so as to determine, where to open the portal

    const dropdownRef = useRef();
    const to_doRef = useRef(null);
    const dateRef = useRef(null);
    const dispatch = useDispatch();
    const PortalForEMailDropdown = withPortalHOC(EmailDropDownComponent);
    const PortalForEmailPersonInfo = withPortalHOC(EmailPersonInfo);
    const PortalList = withPortalHOC(List);
    const [fieldName, setFieldName] = useState(null);

    // const [selectedContent, setSelectedContent] = useState("Task");

    const [showViewList, setShowViewList] = useState(false);
    const [DateViewContent, setDateViewContent] = useState(false);
    const [isCustomDateView, setIsCustomDateView] = useState(false);
    const [selectedTags, setSelectedTags] = useState([]);

    const [optionDataColered, setOptionDataColered] = useState(null);

    const {
      data: allNotesTagsList,
      isError: isNotesTagsListError,
      isSuccess: isNotesTagsListSuccess,
      error: notesTagsListError,
      isLoading: isNotesTagsListLoading,
      refetch: refetchNotesTagsList,
    } = useFetchNoteTagsQuery();

    const TaskToDoData = [
      { label: "Task", value: "Task" },
      { label: "Deal", value: "Deal" },
      { label: "Lead", value: "Lead" },
      { label: "Job", value: "Job" },
    ];

    // const DaysToFollowUp = [
    //   { label: "Tomorrow", value: "Tomorrow" },
    //   { label: "Day After", value: "Day After" },
    // ];

    const DaysToFollowUp = Array.from({ length: 2 }).map((_, idx) => {
      const actualIndex = idx + 1;
      const date = moment().add(actualIndex, "days");
      const formattedDate = date.format("DD MMM");

      const dayLabel = actualIndex === 1 ? "Tomorrow" : "Day After";

      return {
        label: `${dayLabel} (${formattedDate})`,
        value: dayLabel,
        date: formattedDate,
      };
    });

    console.log(DaysToFollowUp);

    // const [selectedDate, setSelectedDate] = useState("Tomorrow");

    const [isChecked, setIsChecked] = useState(false);

    const handleCheckboxChange = (e) => {
      setIsChecked(e.target.checked);
    };

    const handleSelectContent = (selected) => {
      setSelectedContent(selected?.value); // store only value
      setShowViewList(false);
    };

    const selectedDateOption = DaysToFollowUp.find((item) => item.value === selectedDate);
    console.log(selectedDateOption, "selectedDateOption");

    const handleSelectDate = (selectedOption) => {
      setSelectedDate(selectedOption?.value); // { label, value }
    };

    const rgbToHex = (rgb) => {
      const [r, g, b] = rgb.match(/\d+/g);
      const hexR = (+r).toString(16).padStart(2, "0");
      const hexG = (+g).toString(16).padStart(2, "0");
      const hexB = (+b).toString(16).padStart(2, "0");
      return `#${hexR}${hexG}${hexB}`;
    };

    const handleTextboxKeyDown = (event) => {
      if (event.key !== "Backspace") return;

      const sel = window.getSelection();
      if (!sel || sel.rangeCount === 0) return;

      const range = sel.getRangeAt(0);
      // Only handle collapsed caret here — normal range deletions should keep browser behavior.
      if (!range.collapsed) return;

      const { anchorNode, anchorOffset } = sel;

      // helper to remove mention id from state given an anchor element
      const removeMentionFromState = (anchorEl) => {
        if (!anchorEl || anchorEl.nodeType !== Node.ELEMENT_NODE) return;
        const mentionId =
          anchorEl.dataset?.mentionId ||
          anchorEl.dataset?.email ||
          anchorEl.dataset?.uuid ||
          anchorEl.dataset?.personId;
        if (!mentionId) return;

        setMentions((prev) => prev.filter((m) => m !== mentionId));
      };

      // Find an <a data-mention="true"> element that should be deleted:
      // - caret is inside a text node whose parent is the anchor
      // - caret is inside the anchor element itself
      // - caret is at offset 0 of a text node or element and previous sibling is the anchor
      let mentionAnchor = null;

      try {
        if (anchorNode) {
          // Case A: caret inside a text node and that text node's parent is the anchor
          if (
            anchorNode.nodeType === Node.TEXT_NODE &&
            anchorNode.parentElement?.tagName === "A" &&
            anchorNode.parentElement.dataset?.mention === "true"
          ) {
            mentionAnchor = anchorNode.parentElement;
          }

          // Case B: caret is inside the anchor element (element node is anchor)
          if (!mentionAnchor && anchorNode.nodeType === Node.ELEMENT_NODE) {
            // If the caret is inside an <a> (the anchor itself)
            if (anchorNode.tagName === "A" && anchorNode.dataset?.mention === "true") {
              mentionAnchor = anchorNode;
            } else {
              // look for node immediately before the caret
              const prevNode = anchorNode.childNodes[anchorOffset - 1] || anchorNode.previousSibling;
              if (
                prevNode &&
                prevNode.nodeType === Node.ELEMENT_NODE &&
                prevNode.tagName === "A" &&
                prevNode.dataset?.mention === "true"
              ) {
                mentionAnchor = prevNode;
              }
            }
          }

          // Case C: caret in a text node at offset 0 and previousSibling is the anchor
          if (!mentionAnchor && anchorNode.nodeType === Node.TEXT_NODE) {
            if (anchorOffset === 0) {
              const prev = anchorNode.previousSibling;
              if (
                prev &&
                prev.nodeType === Node.ELEMENT_NODE &&
                prev.tagName === "A" &&
                prev.dataset?.mention === "true"
              ) {
                mentionAnchor = prev;
              }
            } else {
              // caret inside text node and the previous sibling inside the same parent is an anchor
              const parent = anchorNode.parentNode;
              if (parent) {
                const nodeBefore =
                  parent.childNodes[
                    Array.prototype.indexOf.call(parent.childNodes, anchorNode) > -1
                      ? Array.prototype.indexOf.call(parent.childNodes, anchorNode)
                      : 0
                  ];
                // fallback: check anchorOffset - 1 within parent's childNodes if available
                const maybePrev = parent.childNodes[anchorOffset - 1];
                if (
                  maybePrev &&
                  maybePrev.nodeType === Node.ELEMENT_NODE &&
                  maybePrev.tagName === "A" &&
                  maybePrev.dataset?.mention === "true"
                ) {
                  mentionAnchor = maybePrev;
                }
              }
            }
          }
        }
      } catch (err) {
        // If DOM queries fail for some reason, don't crash — let browser handle default
        console.warn("mention-detect error", err);
      }

      // If we found a mention anchor — delete the whole anchor and update state
      if (mentionAnchor) {
        event.preventDefault();

        // remove mention id from state
        removeMentionFromState(mentionAnchor);

        // Replace the anchor with a single empty text node (so caret can be placed there)
        const parent = mentionAnchor.parentNode;
        if (!parent) {
          mentionAnchor.remove();
          return;
        }
        const emptyText = document.createTextNode("");
        parent.replaceChild(emptyText, mentionAnchor);

        // place caret inside new text node
        const newRange = document.createRange();
        newRange.setStart(emptyText, 0);
        newRange.collapse(true);
        sel.removeAllRanges();
        sel.addRange(newRange);

        return;
      }

      // --- FALLBACK: keep your earlier special handling for ZWSP/NBSP or the case when previous sibling is an <a>
      // If caret sits inside a text node
      if (anchorNode && anchorNode.nodeType === Node.TEXT_NODE) {
        const textNode = anchorNode;

        // If there's a zero-width-space directly before caret (zwsp or NBSP or space), remove it + previous mention link
        if (
          anchorOffset > 0 &&
          (textNode.textContent[anchorOffset - 1] === "\u200B" ||
            textNode.textContent[anchorOffset - 1] === "\u00A0" ||
            textNode.textContent[anchorOffset - 1] === " ")
        ) {
          event.preventDefault();

          // Remove that single character (zwsp or nbps or space)
          const delRange = document.createRange();
          delRange.setStart(textNode, anchorOffset - 1);
          delRange.setEnd(textNode, anchorOffset);
          delRange.deleteContents();

          const prev = textNode.previousSibling;
          if (prev && prev.nodeType === Node.ELEMENT_NODE && prev.tagName === "A" && prev.dataset?.mention === "true") {
            removeMentionFromState(prev);
            prev.remove();
          }

          // Place caret sensibly
          let insertAfterNode = textNode.previousSibling;
          if (insertAfterNode && insertAfterNode.nodeType === Node.TEXT_NODE) {
            sel.collapse(insertAfterNode, insertAfterNode.textContent.length);
          } else {
            const newText = document.createTextNode("");
            textNode.parentNode.insertBefore(newText, textNode.nextSibling);
            sel.collapse(newText, 0);
          }

          return;
        }

        // If caret at offset 0 and previous sibling is a mention link, delete that link as a unit
        if (anchorOffset === 0) {
          const prevSibling = textNode.previousSibling;
          if (
            prevSibling &&
            prevSibling.nodeType === Node.ELEMENT_NODE &&
            prevSibling.tagName === "A" &&
            prevSibling.dataset?.mention === "true"
          ) {
            event.preventDefault();
            removeMentionFromState(prevSibling);
            prevSibling.remove();
            sel.collapse(textNode, 0);
            return;
          }
        }
      }

      // Also handle case where selection is collapsed inside an element node (not text)
      if (anchorNode && anchorNode.nodeType === Node.ELEMENT_NODE) {
        const el = anchorNode;
        const prevNode = el.childNodes[anchorOffset - 1] || el.previousSibling;
        if (
          prevNode &&
          prevNode.nodeType === Node.ELEMENT_NODE &&
          prevNode.tagName === "A" &&
          prevNode.dataset?.mention === "true"
        ) {
          event.preventDefault();
          removeMentionFromState(prevNode);
          prevNode.remove();

          // place caret sensibly after removal
          try {
            const sel2 = window.getSelection();
            const range2 = document.createRange();
            const before = prevNode.previousSibling;
            if (before && before.nodeType === Node.TEXT_NODE) {
              range2.setStart(before, before.textContent.length);
            } else {
              range2.setStart(el, 0);
            }
            range2.collapse(true);
            sel2.removeAllRanges();
            sel2.addRange(range2);
          } catch (err) {
            // ignore
          }
          return;
        }
      }

      // default behavior
    };

    //for the email dropdown when we type @ in our textbox

    const handleTextboxInput = (event) => {
      const sel = window.getSelection();
      if (!sel || sel.rangeCount === 0) {
        setShowMentionPortal(false);
        return;
      }

      const range = sel.getRangeAt(0);
      const anchorNode = sel.anchorNode;
      const anchorOffset = sel.anchorOffset;
      const container = event.target;

      // Build absolute offset of caret within container.textContent using TreeWalker
      let absoluteOffset = 0;
      const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null);
      let node;
      let found = false;
      while ((node = walker.nextNode())) {
        if (node === anchorNode) {
          absoluteOffset += anchorOffset;
          found = true;
          break;
        } else {
          absoluteOffset += node.textContent.length;
        }
      }
      if (!found) {
        // fallback
        absoluteOffset = (container.textContent || "").length;
      }

      const fullText = container.textContent || "";
      const beforeCursor = fullText.slice(0, absoluteOffset);
      const match = beforeCursor.match(/(^|\s)@$/);

      if (!match) {
        setShowMentionPortal(false);
        return;
      }

      // Prevent duplicate mention if there's already a mention element right before caret
      // Find DOM node immediately before caret
      let nodeBeforeCaret = null;
      if (anchorNode.nodeType === Node.TEXT_NODE) {
        if (anchorOffset > 0) {
          // The char is in this text node (likely the '@')
          nodeBeforeCaret = anchorNode;
        } else {
          nodeBeforeCaret = anchorNode.previousSibling;
        }
      } else {
        nodeBeforeCaret = anchorNode.childNodes[anchorOffset - 1] || anchorNode.previousSibling;
      }

      // If there's already a mention or a created <a>, bail and reuse it
      if (nodeBeforeCaret) {
        if (nodeBeforeCaret.nodeType === Node.ELEMENT_NODE) {
          const el = nodeBeforeCaret;
          if (
            el.id?.startsWith("mention-span-") ||
            el.dataset?.mention === "true" ||
            (el.tagName === "A" && el.dataset?.mention === "true")
          ) {
            setShowMentionPortal(true);
            mentionRef.current = el;
            return;
          }
        } else if (nodeBeforeCaret.nodeType === Node.TEXT_NODE) {
          // If plain text node has a leftover '@' char immediately before caret, remove it so we don't create duplicate '@'
          if (anchorOffset > 0 && anchorNode.textContent[anchorOffset - 1] === "@") {
            const delRange = document.createRange();
            delRange.setStart(anchorNode, anchorOffset - 1);
            delRange.setEnd(anchorNode, anchorOffset);
            delRange.deleteContents();
            // adjust selection to the deletion point
            sel.collapse(anchorNode, anchorOffset - 1);
          }
        }
      }

      // Now insert unique mention span at current selection range
      const mentionSpan = document.createElement("span");
      mentionSpan.id = `mention-span-${Date.now()}`;
      mentionSpan.textContent = "@";
      mentionSpan.dataset.mention = "temp"; // mark as temporary mention span

      // Use the current range to insert the span
      range.deleteContents();
      range.insertNode(mentionSpan);

      // Move caret after the span
      range.setStartAfter(mentionSpan);
      range.collapse(true);
      sel.removeAllRanges();
      sel.addRange(range);

      // Store ref and show portal
      mentionRef.current = mentionSpan;
      setShowMentionPortal(true);
    };

    const handleTextData = (event) => {
      const isBold = document.queryCommandState("bold");
      const isItalic = document.queryCommandState("italic");
      const isUnderline = document.queryCommandState("underline");
      const fontSize = document.queryCommandValue("fontSize");
      const fontName = document.queryCommandValue("fontName");
      const isUnordered = document.queryCommandState("insertUnorderedList");
      const isOrdered = document.queryCommandState("insertOrderedList");
      const foreColor = document.queryCommandValue("foreColor");
      const isCopy = document.queryCommandState("copy");
      const hexColor = rgbToHex(foreColor);
      let formatblock = document.queryCommandValue("formatblock");
      const content = event.target.textContent;
      const words = content
        .trim()
        .split(/\s+/)
        .filter((word) => word?.length > 0);
      setActiveFormatting((prevState) => ({
        ...prevState,
        bold: isBold,
        italic: isItalic,
        underline: isUnderline,
        fontSize: fontSize,
        fontName: fontName,
        insertUnorderedList: isUnordered,
        insertOrderedList: isOrdered,
        foreColor: foreColor,
        copy: isCopy,
        formatblock: formatblock,
        wordcount: words?.length,
        charactercount: content?.length,
      }));
    };

    const handleButtonClick2 = (event) => {
      const selection = window.getSelection();

      if (selection.toString().length < 1) {
        setNoTextSelected(true);
      }
      const elementvalue = event.target.value;

      const button = event.currentTarget.getAttribute("data-styletag");

      document.execCommand(button, false, elementvalue);

      setActiveFormatting((prevState) => ({
        ...prevState,
        [button]: elementvalue ? elementvalue : !prevState[button],
      }));

      if (button === "copy") {
        setTimeout(() => {
          setActiveFormatting((prevState) => ({
            ...prevState,
            copy: false,
          }));
          setNoTextSelected(false);
        }, 1000);
      }
    };

    const handleButtonClick = (event) => {
      if (textareaRef?.current) textareaRef.current.focus();

      const elementvalue = event.target.value;
      const button = event.currentTarget.getAttribute("data-styletag");

      console.log("button note COpy", button, elementvalue, document.queryCommandState(button));

      // Detect list state BEFORE toggling
      const isUnorderedActive = document.queryCommandState("insertUnorderedList");
      const isOrderedActive = document.queryCommandState("insertOrderedList");

      // Toggle logic for list buttons
      if (button === "insertUnorderedList") {
        if (isUnorderedActive) {
          document.execCommand("insertUnorderedList", false, null); // toggle off
        } else {
          document.execCommand("insertOrderedList", false, null); // turn off opposite
          document.execCommand("insertUnorderedList", false, null); // turn on
        }
      } else if (button === "insertOrderedList") {
        if (isOrderedActive) {
          document.execCommand("insertOrderedList", false, null); // toggle off
        } else {
          document.execCommand("insertUnorderedList", false, null); // turn off opposite
          document.execCommand("insertOrderedList", false, null); // turn on
        }
      } else {
        // All other formatting buttons (bold, italic, etc.)
        document.execCommand(button, false, elementvalue);
      }

      console.log("button note COpy after", button, elementvalue, document.queryCommandState(button));

      // Re-read active states after toggle
      const isBold = document.queryCommandState("bold");
      const isItalic = document.queryCommandState("italic");
      const isUnderline = document.queryCommandState("underline");
      const isUnordered = document.queryCommandState("insertUnorderedList");
      const isOrdered = document.queryCommandState("insertOrderedList");
      const fontSize = document.queryCommandValue("fontSize");
      const fontName = document.queryCommandValue("fontName");
      const foreColor = document.queryCommandValue("foreColor");
      const hexColor = rgbToHex(foreColor);
      let formatblock = document.queryCommandValue("formatblock");

      setActiveFormatting((prevState) => ({
        ...prevState,
        bold: isBold,
        italic: isItalic,
        underline: isUnderline,
        fontSize: fontSize,
        fontName: fontName,
        foreColor: foreColor,
        formatblock: formatblock,
        insertUnorderedList: isUnordered,
        insertOrderedList: isOrdered,
      }));

      if (button === "copy") {
        setTimeout(() => {
          setActiveFormatting((prevState) => ({
            ...prevState,
            copy: false,
          }));
        }, 1000);
      }
    };

    const handleParaHead = (value) => {
      textareaRef.current.focus();

      document.execCommand("formatblock", false, value);
      setActiveFormatting((prevState) => ({
        ...prevState,
        formatblock: value,
      }));
      setParaHeadOpen(false);
    };
    useImperativeHandle(ref, () => ({
      clearContent: () => {
        setContent("");
        setInitialContent("");
      },
    }));

    const getFileLastNames = (filePath) => {
      if (typeof filePath === "string" && filePath.includes("/")) {
        return true;
      } else {
        return false;
      }
    };

    const downloadFile = (file) => {
      if ((!file) instanceof Blob) {
        console.error("File object is invalid or empty.");
        return;
      }
      try {
        const url = URL.createObjectURL(file);
        const a = document.createElement("a");
        a.href = url;
        a.download = file.name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error creating object URL:", error);
      }
    };

    const toggleDropdown = (e) => {
      const buttonRect = e.target.getBoundingClientRect();
      setDropdownPosition({
        top: buttonRect.bottom,
        left: buttonRect.left,
        width: buttonRect.width,
      });
      setParaHeadOpen(!paraHeadOpen);
    };
    const formRef = useRef(null);
    const handleInsertColur = (color) => {
      handleSetColour(color);
    };

    const handleColorClick = () => {
      textareaRef.current.focus();
      document.execCommand("foreColor", false, selectedColor);
      setActiveFormatting((prev) => ({
        ...prev,
        foreColor: selectedColor,
      }));
    };

    const handleColorChange = (event) => {
      const newColor = event.target.value;
      setSelectedColor(newColor);
      document.execCommand("foreColor", false, newColor);
      setActiveFormatting((prev) => ({
        ...prev,
        foreColor: newColor,
      }));
    };

    useEffect(() => {
      if (formData?.notes_category_id === "" && customerTaskCategory?.data?.notes.length > 0) {
        handleInputChange({ target: { name: "notes_category_id", value: customerTaskCategory.data.notes[0].id } });
      }
    }, [customerTaskCategory]);

    const toggleTagDropdown = (e) => {
      setIsOpen((prev) => !prev);
      refetchNotesTagsList();
    };

    const handleOptionClick = (options, isRemove) => {
      if (isRemove) {
        const updatedOptions = selectedOptions.filter((option) => option.value !== options.value);
        setSelectedOptions(updatedOptions);
      } else setSelectedOptions(options);
    };

    const handleCustomViewClick = () => {
      setDateViewContent(false);
      setIsCustomDateView(true);
    };

    const handleAddTag = (tag) => {
      const label = getTitleCase(tag.value);

      const tagObj = { label, ...tag };
      setSelectedOptions((prev) => [...prev, tagObj]);
      setOptionDataColered((prev) => [tagObj, ...prev]);
      // setSelectedOptions((prev) => [...prev, { label: tag, value: tag, color_code: predefinedColors[0] }]);
    };

    const handleDateChange = (date) => {
      const formatted = moment(date).format("DD MMM YYYY");
      setSelectedDate(formatted);
      // setIsCustomDateView(false);
    };

    useEffect(() => {
      const root = textareaRef.current;
      if (!root) return;

      const onClick = async (e) => {
        // find the ancestor anchor with data-mention
        const a = e.target?.closest?.('a[data-mention="true"]');
        if (!a || !root.contains(a)) return;

        e.preventDefault();
        e.stopPropagation();

        // Build a small person object from dataset
        const person = {
          id: a.dataset.personId || null,
          uuid: a.dataset.uuid || null,
          name: a.dataset.name || a.textContent || null,
          email: a.dataset.email || null,
        };

        // Save the anchor element for positioning
        portalAnchorRef.current = a;

        // Optionally fetch fresh details by uuid here if you want freshest data:
        // if (person.uuid) { await fetchAndSetPerson(person.uuid); }

        // Open your portal
        setClickedPerson(person);
        setMentionInfoVisible(true);

        // Move caret out of link (optional: to avoid typed text inheriting link style)
        try {
          // create or find a text node after the link
          let next = a.nextSibling;
          if (!next || next.nodeType !== Node.TEXT_NODE) {
            next = document.createTextNode("");
            a.parentNode.insertBefore(next, a.nextSibling);
          }
          // place caret inside it
          const sel = window.getSelection();
          const range = document.createRange();
          range.setStart(next, next.length);
          range.collapse(true);
          sel.removeAllRanges();
          sel.addRange(range);
          // blur anchor
          if (typeof a.blur === "function") a.blur();
          // ensure editor is focused
          textareaRef.current?.focus?.();
        } catch (err) {
          // ignore caret relocation errors, portal still opens
          console.warn("Could not move caret after link:", err);
        }
      };

      root.addEventListener("click", onClick);
      return () => root.removeEventListener("click", onClick);
    }, [textareaRef.current]); // include other deps if used (portalAnchorRef etc.)

    useEffect(() => {
      const rebuildFromDom = () => {
        const root = textareaRef?.current;
        if (!root) return;
        const anchors = Array.from(
          root.querySelectorAll(
            'a[data-mention="true"][data-mention-id], a[data-mention="true"][data-mentionid], a[data-mention="true"]'
          )
        );
        const ids = anchors
          .map((a) => a.dataset?.mentionId || a.dataset?.email || a.dataset?.uuid || a.dataset?.personId)
          .filter(Boolean);
        setMentions(ids);
      };

      // call once after mount/refill
      rebuildFromDom();
    }, [textareaRef?.current, notesBody]);

    // handle email select from the dropdown

    const handleEmailSelect = (person) => {
      if (!mentionRef.current) return;

      // choose stable id to store for mentions (prefer email, fallback to uuid or personId)
      const mentionId = person?.email || person?.uuid || String(person?.id ?? "");

      // Create link element
      const link = document.createElement("a");
      link.textContent = person.name;
      link.style.color = "#1D4469";
      link.style.textDecoration = "underline";
      link.style.cursor = "pointer";
      link.id = `email-link-${person.id}-${Date.now()}`;

      // Persist identifying data so links still work after rehydration
      link.dataset.mention = "true";
      link.dataset.personId = String(person.id ?? "");
      link.dataset.uuid = String(person.uuid ?? "");
      link.dataset.name = String(person.name ?? "");
      link.dataset.email = String(person.email ?? "");
      link.dataset.mentionId = mentionId; // canonical mention id

      // Replace the mention span (or whatever element is stored) with the link
      mentionRef.current.replaceWith(link);

      // Create a neutral span (resets link styling) containing a visible non-breaking space
      const neutralSpan = document.createElement("span");
      neutralSpan.style.color = "inherit";
      neutralSpan.style.textDecoration = "none";
      const nbspNode = document.createTextNode("\u00A0");
      neutralSpan.appendChild(nbspNode);

      // insert the neutral span immediately after the link
      if (link.nextSibling) {
        link.parentNode.insertBefore(neutralSpan, link.nextSibling);
      } else {
        link.parentNode.appendChild(neutralSpan);
      }

      // Ensure editor has focus then place caret inside the neutral span (after the NBSP)
      try {
        textareaRef?.current?.focus?.();

        const sel = window.getSelection();
        const range = document.createRange();

        // place caret after the NBSP inside the neutral span
        range.setStart(neutralSpan.firstChild, 1);
        range.collapse(true);

        sel.removeAllRanges();
        sel.addRange(range);

        // remove focus from the link to avoid any :focus styles
        if (typeof link.blur === "function") link.blur();
      } catch (err) {
        // Fallback: place caret after the neutral span
        const sel = window.getSelection();
        const range = document.createRange();
        range.setStartAfter(neutralSpan);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
      }

      // add mention id to mentions state (avoid duplicates)
      setMentions((prev) => {
        if (!mentionId) return prev;
        if (prev.includes(mentionId)) return prev;
        return [...prev, mentionId];
      });

      setShowMentionPortal(false);
    };

    const [mentionInfoVisible, setMentionInfoVisible] = useState(false);
    const [clickedPerson, setClickedPerson] = useState(null);

    const portalAnchorRef = useRef(null);

    const handleEmailHyperLinkClick = (person, e) => {
      const el = e.currentTarget || e.target;
      portalAnchorRef.current = el;
      setMentionInfoVisible(true);
      setClickedPerson(person);
    };

    useEffect(() => {
      if (isNotesTagsListSuccess && allNotesTagsList?.data?.length) {
        //    const formattedOptions = allNotesTagsList.data.map(option => ({
        //   label: option.label,
        //   value: option.id,
        //   color_code: option.color_code,
        // }));
        setOptionDataColered(allNotesTagsList?.data);
        setFieldName(allNotesTagsList?.field_name);
      }
    }, [isNotesTagsListSuccess, isNotesTagsListError, notesTagsListError, allNotesTagsList?.data]);

    const handleFieldOptionAdd = async (optionData, OldOtion) => {
      try {
        let body = {
          value: optionData.value,

          ...(OldOtion?.id && { id: OldOtion?.id }),
        };

        if (optionData?.color_code) {
          body = {
            value: optionData?.value,
            color: optionData?.color_code,

            ...(OldOtion?.id && { id: OldOtion.id }),
          };
        }
        const response = await createOption({ query: { field_name: fieldName }, body });

        if (response?.status) {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.data?.message,
              type: "success",
            })
          );
          refetchNotesTagsList();
        } else {
          dispatch(
            pushAlert({
              visible: true,
              message: response?.data?.message,
              type: "danger",
            })
          );
        }
      } catch (error) {
        dispatch(
          pushAlert({
            visible: true,
            message: error?.message || "Something went wrong",
            type: "danger",
          })
        );
      }
    };

    return (
      <>
        <PortalForEMailDropdown
          open={showMentionPortal}
          containerRef={mentionRef}
          onClose={() => setShowMentionPortal(false)}
          handleEmailSelect={handleEmailSelect}
        />

        <PortalForEmailPersonInfo
          open={mentionInfoVisible}
          onClose={() => setMentionInfoVisible(false)}
          containerRef={portalAnchorRef}
          person={clickedPerson}
        />

        <form onSubmit={handleSubmit} ref={formRef} className="mb-1">
          <div className=" border border-D2DAE1 rounded-5px overflow-y-auto py-2">
            <div className="grid">
              <div className={`flex flex-row relative gap-2 mb-2 items-center w-full`}>
                <div className=" border-b flex items-center justify-center w-full bg-[#F5F5F5]">
                  <div className=" flex items-center justify-center h-full border-r w-full gap-x-3 px-2 bg-[#F5F5F5]">
                    <input
                      type="text"
                      placeholder="Title:"
                      className={` w-full border-none text-[#666666] bg-[#F5F5F5] rounded-5px focus:ring-0 h-[35px] outline-0 focus:border-none placeholder:font-normal`}
                      onClick={() => handleNotesClick("addnotes")}
                      onChange={handleInputChange}
                      name="notes_title"
                      value={formData?.notes_title !== "" ? formData.notes_title : ""}
                    />

                    <div
                      className=" flex relative gap-2 items-center cursor-pointer justify-center px-2 bg-[#F5F5F5]"
                      // datatype="tags"
                    >
                      <Addtag />
                      <span
                        className="text-[#666]  font-normal text-sm whitespace-nowrap"
                        ref={dropdownRef}
                        onClick={(e) => toggleTagDropdown(e)}
                      >
                        Add Tag{" "}
                      </span>
                      {isOpen && (
                        <PortalList
                          containerRef={dropdownRef}
                          open={isOpen}
                          xAxis={-90}
                          yAxis={18}
                          onClose={() => {
                            setIsOpen(false);
                          }}
                          onChange={() => {}}
                          options={optionDataColered}
                          showSearch
                          multiSelect
                          // isTagList
                          addButton
                          valueKey="id"
                          // addButtonLabel="Add New Tag"
                          isEditList
                          addButtonAction={(val) => handleFieldOptionAdd(val)}
                          editListHandler={(val, val2) => handleFieldOptionAdd(val2, val)}
                          inlineCrud
                          size={"medium"}
                          selectedOptions={selectedOptions}
                          setSelectedOptions={setSelectedOptions}
                          onOptionClick={handleOptionClick}
                        />
                      )}
                    </div>
                  </div>
                  <div className="px-4 ">
                    <ColorDropdown
                      colors={customerColor}
                      handleInsertColur={handleInsertColur}
                      onChange={handleInputChange}
                      colourCodes={colourCodes}
                    />
                  </div>
                </div>
              </div>
              <div className="relative">
                <div
                  role="textbox"
                  contentEditable={true}
                  ref={textareaRef}
                  dangerouslySetInnerHTML={{ __html: notesBody }}
                  className={`text-12 font-500 opacity-100  w-full  px-4 py-2 min-h-72 max-h-[50vh] overflow-auto  notesckeditor resize-y focus:ring-0   focus:outline-none focus:border-778FA5`}
                  placeholder="Type Something . . ."
                  onKeyUp={handleTextData}
                  onInput={handleTextboxInput}
                  onKeyDown={handleTextboxKeyDown} // <-- added
                ></div>

                <div className="flex flex-wrap gap-2 px-4 py-2 h-7 mb-2">
                  {selectedOptions?.map((option) => {
                    return (
                      <span
                        key={option?.value}
                        className="text-white text-xs font-medium px-2 py-1 rounded items-center"
                        style={{
                          backgroundColor: getHexWithOpacity(option?.color_code, 10) || "#666",
                          color: option?.color_code,
                          border: `1px solid ${option?.color_code}`,
                        }}
                      >
                        {option?.label}
                        {console.log("Selectedvinay", option?.label)}
                        <button
                          type="button"
                          className={`ml-2 text-${option?.color_code}`}
                          onClick={() => handleOptionClick(option, true)}
                        >
                          <i className="bi bi-x"></i>
                        </button>
                      </span>
                    );
                  })}
                </div>

                {/* Uncomment for task Create in Notes */}

                {/* <div
                className={`flex items-center gap-2 px-2 py-1 mx-4  rounded-md mt-4 ${isCreateTask ? "opacity-100" : "opacity-70 cursor-not-allowed"}`}
              >
                <input
                  type="checkbox"
                  className=" h-4 w-4 rounded border-gray-400 bg-white text-[#767676] focus:ring-0 focus:outline-none cursor-pointer"
                  id="to-do-data"
                  name="to_do_data"
                  onChange={handleCheckboxChange}
                  checked={isChecked}
                />
                <div className="flex items-center text-[#383838] font-normal text-base">
                  Add
                  <div className="relative w-fit ml-2 ">
                    <div
                      className="text-[#1D4469] text-base font-medium whitespace-nowrap  flex items-center gap-1 bg-white px-2 py-0.5 rounded-md"
                      ref={to_doRef}
                    >
                      <div className="flex items-center gap-2 ">
                        <span className="text-[#1D4469] font-medium">{selectedContent}</span>
                        <div
                          className={` ${isChecked ? "cursor-pointer" : "cursor-not-allowed"}`}
                          onClick={() => {
                            if (!isChecked) return; // Prevent action if checkbox is not checked
                            setShowViewList((prev) => !prev);
                          }}
                        >
                          <DownArrow
                            fill={isChecked === true && showViewList ? "#383838" : "#383838"}
                            className={`transition-transform duration-200 h-3 w-3 rounded-sm  ${isChecked === true && showViewList ? "rotate-180 " : "rotate-0 "}`}
                          />
                        </div>
                      </div>
                    </div>

                    {isChecked === true && showViewList && (
                      <div className="absolute  mt-1  bg-white shadow border rounded-md ">
                        <PortalList
                          open={showViewList}
                          onClose={() => setShowViewList(false)}
                          containerRef={to_doRef}
                          options={TaskToDoData}
                          selectedOptions={[TaskToDoData.find((opt) => opt.value === selectedContent)]}
                          setSelectedOptions={(selected) => setSelectedContent(selected[0]?.value)}
                          onOptionClick={(selected) => handleSelectContent(selected[0])}
                          size="medium"
                          name="TaskToDoData"
                        />
                      </div>
                    )}
                  </div>
                </div>

                <div className="flex items-center text-[#383838] text-base font-normal">
                  to follow up
                  <div className="relative ml-2">
                    <div
                      className=" py-1 flex items-center  border border-transparent  h-full rounded-md"
                      ref={dateRef}
                    >
                      <span className=" whitespace-nowrap flex items-center gap-2 bg-white px-2 py-0.5 rounded-md">
                        <span className="text-[#1D4469]  font-medium ">
                          {selectedDateOption?.label || selectedDate}
                        </span>
                        <div
                          className={` ${isChecked ? "cursor-pointer" : "cursor-not-allowed"}`}
                          onClick={() => {
                            if (!isChecked) return; // Prevent action if checkbox is not checked
                            setDateViewContent((prev) => !prev);
                            setIsCustomDateView(false); // close date picker
                          }}
                        >
                          <DownArrow
                            fill={isChecked === true && DateViewContent ? "#383838" : "#383838"}
                            className={`transition-transform duration-200 h-3 w-3 ${isChecked === true && DateViewContent ? "rotate-180" : "rotate-0"}`}
                          />
                        </div>
                      </span>
                    </div>

                    <div>
                      {isChecked === true && DateViewContent && (
                        <div className="absolute top-full mt-1  shadow border rounded-md z-10">
                          <PortalList
                            open={DateViewContent}
                            onClose={() => setDateViewContent(false)}
                            containerRef={dateRef}
                            options={DaysToFollowUp}
                            selectedOptions={[DaysToFollowUp.find((item) => item.value === selectedDate)]}
                            setSelectedOptions={(selected) => setSelectedDate(selected[0]?.value)}
                            onOptionClick={(selected) => {
                              handleSelectDate(selected[0]);
                              setDateViewContent(false);
                            }}
                            size="medium"
                            name="dateContent"
                            addButton
                            addButtonLabel="Custom Date"
                            addButtonAction={handleCustomViewClick}
                          />
                        </div>
                      )}

                      {isCustomDateView && (
                        <div className="">
                          <DatePickerComponent
                            dateFormat="dd MMM yyyy"
                            placeholderText="DD MM YYYY"
                            showYearDropdown
                            autoOpen
                            showMonthDropdown
                            scrollableYearDropdown
                            border="hidden"
                            onChange={handleDateChange}
                            boxHidden
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div> */}
              </div>

              <div className="flex flex-row flex-wrap justify-start my-2 mb-4 gap-15px px-4">
                {selectedFile?.length > 0 &&
                  selectedFile.map((file, index) => (
                    <div key={index} className="relative flex">
                      <div className="truncate border border-D2DAE1 py-1 px-3 rounded-5px">
                        {file.file_name ? file.file_name : file.attachment}
                      </div>
                      {file?.id ? (
                        <Fragment>
                          <button
                            type="button"
                            onClick={() => handleDeleteFileServer(file.id, editNoteId)}
                            className="m-1"
                          >
                            <i className="bi bi-x-circle text-red-500"></i>
                          </button>
                        </Fragment>
                      ) : (
                        <Fragment>
                          <button type="button" onClick={() => handleClickDeleteFile(index)} className="m-1">
                            <i className="bi bi-x-circle text-red-500"></i>
                          </button>
                        </Fragment>
                      )}
                    </div>
                  ))}
              </div>

              <div className="flex justify-between w-full items-center border-D2DAE1 bg-primary-active py-2 px-3">
                <div className="min-w-0 grow border-ynm  flex align-center ps-2">
                  <div className="flex items-center">
                    <div className="pe-2 border-r border-B3B3B3 inline-block">
                      <button
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileUpload();
                        }}
                      >
                        <i className="bi bi-paperclip text-2xl text-8997A0"></i>
                      </button>
                    </div>
                    <div className="text-xs px-4 flex">
                      <span className="mx-1 flex">
                        Words: <div className="min-w-7 pl-1">{activeFormatting.wordcount}</div>
                      </span>
                      <span className="mx-1 flex">
                        Characters: <div className="min-w-10 pl-1">{activeFormatting.charactercount}</div>
                      </span>
                    </div>

                    <EmojiesDrop textareaRef={textareaRef} />

                    <div className="inline-block text-left relative ml-4">
                      <div>
                        <button
                          type="button"
                          className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 capitalize"
                          onClick={(e) => toggleDropdown(e)}
                          aria-expanded={paraHeadOpen}
                          aria-haspopup="true"
                        >
                          {activeFormatting.formatblock || "p"}

                          <i className={`bi bi-${paraHeadOpen ? "caret-up" : "caret-down"} text-gray-400`}></i>
                        </button>
                      </div>

                      <CreatePortalHOC
                        isOpen={paraHeadOpen}
                        onClose={() => setParaHeadOpen(false)}
                        position={dropdownPosition}
                      >
                        {/* {paraHeadOpen && ( */}
                        <div
                          className="absolute z-10 mt-1 w-56 origin-top-right rounded-md bg-white shadow-lg  ring-white ring-opacity-5 focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          tabIndex="-1"
                        >
                          <div className="py-1" role="none">
                            <button
                              type="button"
                              className={`text-gray-700 block w-full px-4 py-1 text-left text-xs hover:bg-gray-200 ${
                                activeFormatting.formatblock === "p" ? "bg-1D4469  text-white" : ""
                              }`}
                              onClick={() => handleParaHead("p")}
                              tabIndex="-1"
                            >
                              Paragraph
                            </button>
                            <button
                              type="button"
                              className={`text-gray-700 block w-full px-4 py-1 text-left text-xs hover:bg-gray-200 ${
                                activeFormatting.formatblock === "h1" ? "bg-1D4469  text-white" : ""
                              }`}
                              onClick={() => handleParaHead("h1")}
                              tabIndex="-1"
                            >
                              Heading 1
                            </button>
                            <button
                              type="button"
                              className={`text-gray-700 block w-full px-4 py-1 text-left text-xs hover:bg-gray-200 ${
                                activeFormatting.formatblock === "h2" ? "bg-1D4469  text-white" : ""
                              }`}
                              onClick={() => handleParaHead("h2")}
                              tabIndex="-1"
                            >
                              Heading 2
                            </button>
                            <button
                              type="button"
                              className={`text-gray-700 block w-full px-4 py-1 text-left text-xs hover:bg-gray-200 ${
                                activeFormatting.formatblock === "h3" ? "bg-1D4469  text-white" : ""
                              }`}
                              onClick={() => handleParaHead("h3")}
                              tabIndex="-1"
                            >
                              Heading 3
                            </button>
                            <button
                              type="button"
                              className={`text-gray-700 block w-full px-4 py-1 text-left text-xs hover:bg-gray-200 ${
                                activeFormatting.formatblock === "h4" ? "bg-1D4469  text-white" : ""
                              }`}
                              onClick={() => handleParaHead("h4")}
                              tabIndex="-1"
                            >
                              Heading 4
                            </button>
                            <button
                              type="button"
                              className={`text-gray-700 block w-full px-4 py-1 text-left text-xs hover:bg-gray-200 ${
                                activeFormatting.formatblock === "h5" ? "bg-1D4469  text-white" : ""
                              }`}
                              onClick={() => handleParaHead("h5")}
                              tabIndex="-1"
                            >
                              Heading 5
                            </button>
                            <button
                              type="button"
                              className={`text-gray-700 block w-full px-4 py-1 text-left text-xs hover:bg-gray-200 ${
                                activeFormatting.formatblock === "h6" ? "bg-1D4469  text-white" : ""
                              }`}
                              onClick={() => handleParaHead("h6")}
                              tabIndex="-1"
                            >
                              Heading 6
                            </button>
                          </div>
                        </div>
                        {/* )} */}
                      </CreatePortalHOC>
                    </div>
                    <div className="mx-2 ">
                      <select
                        className="form-select w-[45px] h-9 px-2 rounded-5px text-sm"
                        data-styletag="fontSize"
                        onChange={handleButtonClick}
                        value={activeFormatting.fontSize}
                      >
                        <option value={"1"}>1</option>
                        <option value={"2"}>2</option>
                        <option value={"3"}>3</option>
                        <option value={"4"}>4</option>
                        <option value={"5"}>5</option>
                        <option value={"6"}>6</option>
                      </select>
                    </div>

                    <div className="mx-2 relative">
                      <input
                        type="color"
                        id="favcolor"
                        className="color-input"
                        name="favcolor"
                        data-styletag="foreColor"
                        value={activeFormatting.foreColor}
                        onChange={handleColorChange}
                        onClick={handleColorClick}
                      />
                      <div
                        id="custom-colorbox-1"
                        className={`customcolorbox `}
                        style={{ backgroundColor: activeFormatting.foreColor }}
                      >
                        <i className="bi bi-palette-fill text-1D4469"></i>
                      </div>
                    </div>

                    <button
                      type="button"
                      className={`mx-2 ${activeFormatting.bold && "text-2999BC bg-EAEAEA rounded"}`}
                      data-styletag="bold"
                      onClick={handleButtonClick}
                    >
                      <i className="bi bi-type-bold text-xl text-858f96"></i>
                    </button>
                    <button
                      type="button"
                      className={`mx-2  ${activeFormatting.underline && "text-2999BC bg-EAEAEA rounded"}`}
                      data-styletag="underline"
                      onClick={handleButtonClick}
                    >
                      <i className="bi bi-type-underline text-xl text-858f96"></i>
                    </button>
                    <button
                      type="button"
                      className={`mx-2  ${activeFormatting.italic && "text-2999BC bg-EAEAEA rounded"}`}
                      data-styletag="italic"
                      onClick={handleButtonClick}
                    >
                      <i className="bi bi-type-italic text-xl text-858f96"></i>
                    </button>

                    <button
                      type="button"
                      className={`px-2 ${activeFormatting.copy ? "text-2999BC bg-EAEAEA rounded" : ""} relative`}
                      data-styletag="copy"
                      onClick={handleButtonClick2}
                    >
                      <i className="bi bi-copy text-xl text-858f96"></i>
                      {activeFormatting.copy && (
                        <div
                          className={`absolute translate-y-[-70px] translate-x-[-20px] mr-1 p-1 px-2 ${noTextSelected ? "bg-D04921 w-40 translate-x-[-50px]" : "bg-1D4469 translate-x-[-20px]"} text-white rounded`}
                        >
                          {noTextSelected ? "No Text Selected" : "Copied"}
                        </div>
                      )}
                    </button>

                    <button
                      type="button"
                      className={`mx-1 px-1 ${activeFormatting.insertUnorderedList ? "text-2999BC bg-EAEAEA rounded" : ""}`}
                      data-styletag="insertUnorderedList"
                      onClick={handleButtonClick}
                    >
                      <i className="bi bi-list-ul text-xl text-858f96"></i>
                    </button>

                    <button
                      type="button"
                      className={`mx-1 px-1 ${activeFormatting.insertOrderedList ? "text-2999BC bg-EAEAEA rounded" : ""}`}
                      data-styletag="insertOrderedList"
                      onClick={handleButtonClick}
                    >
                      <i className="bi bi-list-ol text-xl text-858f96"></i>
                    </button>

                    <button type="button" className={`mx-2`} data-styletag="undo" onClick={handleButtonClick}>
                      <i className="undo-icon text-858f96"></i>
                    </button>

                    <button type="button" className={`mx-2`} data-styletag="redo" onClick={handleButtonClick}>
                      <i className="redo-icon text-858f96"></i>
                    </button>
                  </div>
                </div>
                <div className="p-3 col-span-full flex justify-end gap-2">
                  <Button variant="secondary" onClick={hndleCloseNotes}>
                    Cancel
                  </Button>
                  <Button type="submit"> Submit</Button>
                </div>

                {/* <div className="flex space-x-2">
                  <button
                    type="button"
                    className="bg-white border border-D2DAE1 rounded-[7px] text-535252 py-1 px-4  hover:bg-[#EBF2F6]"
                    onClick={hndleCloseNotes}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="bg-[#1D4469]  hover:bg-[#092239] border-none rounded-[7px] text-white py-1 px-4 "
                  >
                    Submit
                  </button>
                </div> */}
              </div>
            </div>
          </div>
        </form>
      </>
    );
  }
);

export default ViewNotesData;
